import React from 'react';
import { Store, Package, Droplet, Phone, Mail } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

export const Wholesale = () => {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contacto');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="mayoreo" className="py-16 bg-gradient-to-br from-honey-50 to-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-honey-950 mb-4">
            ¿Tienes una tienda o distribuyes productos naturales?
          </h2>
          <p className="text-lg text-honey-900/80 max-w-3xl mx-auto">
            Trabaja con nosotros y ofrece productos capilares 100% artesanales y naturales a tus clientes
          </p>
        </div>

        {/* Benefits Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-12">
          {/* Precios especiales */}
          <Card className="border-honey-200 hover:shadow-xl transition-all duration-300">
            <CardContent className="p-8">
              <div className="flex items-start space-x-4">
                <div className="w-16 h-16 bg-gradient-to-br from-honey-400 to-honey-600 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <Store className="w-8 h-8 text-white" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-honey-950 mb-3">
                    Precios Especiales para Distribuidores
                  </h3>
                  <p className="text-honey-900/80 mb-4">
                    Ofrecemos condiciones preferenciales y descuentos por volumen para tiendas, spas, estéticas y distribuidores. 
                    Cuanto más compres, mejores precios obtienes.
                  </p>
                  <ul className="space-y-2 text-honey-900/70">
                    <li className="flex items-start">
                      <Package className="w-5 h-5 mr-2 text-honey-600 flex-shrink-0 mt-0.5" />
                      <span>Pedidos mínimos accesibles</span>
                    </li>
                    <li className="flex items-start">
                      <Package className="w-5 h-5 mr-2 text-honey-600 flex-shrink-0 mt-0.5" />
                      <span>Material promocional incluido</span>
                    </li>
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Servicio de rellenado */}
          <Card className="border-honey-200 hover:shadow-xl transition-all duration-300">
            <CardContent className="p-8">
              <div className="flex items-start space-x-4">
                <div className="w-16 h-16 bg-gradient-to-br from-honey-400 to-honey-600 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <Droplet className="w-8 h-8 text-white" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-bold text-honey-950 mb-3">
                    Estaciones de Rellenado a Granel
                  </h3>
                  <p className="text-honey-900/80 mb-4">
                    ¿Tienes una tienda en Guadalajara? Podemos instalar estaciones de rellenado de nuestros productos para que tus clientes 
                    reutilicen sus envases y reduzcan desperdicios.
                  </p>
                  <ul className="space-y-2 text-honey-900/70">
                    <li className="flex items-start">
                      <Droplet className="w-5 h-5 mr-2 text-honey-600 flex-shrink-0 mt-0.5" />
                      <span>Servicio eco-friendly y sustentable</span>
                    </li>
                    <li className="flex items-start">
                      <Droplet className="w-5 h-5 mr-2 text-honey-600 flex-shrink-0 mt-0.5" />
                      <span>Atrae clientes conscientes del medio ambiente</span>
                    </li>
                    <li className="flex items-start">
                      <Droplet className="w-5 h-5 mr-2 text-honey-600 flex-shrink-0 mt-0.5" />
                      <span>Disponible en tiendas de Guadalajara</span>
                    </li>
                  </ul>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>

        {/* CTA Section */}
        <div className="bg-gradient-to-r from-honey-500 to-honey-600 rounded-2xl p-8 md:p-12 text-center text-white shadow-2xl max-w-4xl mx-auto">
          <h3 className="text-2xl md:text-3xl font-bold mb-4">
            ¿Listo para trabajar juntos?
          </h3>
          <p className="text-lg mb-8 text-white/90">
            Contáctanos para conocer nuestras condiciones especiales de mayoreo y servicios de rellenado
          </p>
          
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
            <Button
              onClick={scrollToContact}
              size="lg"
              className="bg-white text-honey-600 hover:bg-honey-50 font-semibold px-8 py-6 text-lg"
            >
              <Mail className="w-5 h-5 mr-2" />
              Enviar mensaje
            </Button>
            
            <a
              href="https://wa.me/523347591562?text=Hola,%20me%20interesa%20información%20sobre%20precios%20de%20mayoreo%20y%20distribución"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex"
            >
              <Button
                size="lg"
                className="bg-green-600 hover:bg-green-700 text-white font-semibold px-8 py-6 text-lg"
              >
                <Phone className="w-5 h-5 mr-2" />
                WhatsApp
              </Button>
            </a>
          </div>

          <p className="mt-6 text-sm text-white/80">
            Respondemos en menos de 24 horas
          </p>
        </div>
      </div>
    </section>
  );
};
